import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CACHE_KEY_HOME_BANNER } from 'src/app/hooks/data/_keys';
import { useBffClient } from 'src/app/hooks/data/useBffClient';
import { useUser } from 'src/app/hooks/data/user';
import useAuth from 'src/app/hooks/useAuth';
import type { CTA } from 'src/app/types';

export enum PrecedingIconType {
  coupon = 'coupon',
}

export interface HomeBannerV1 {
  titleText: string;
  subtitleText: string | null;
  cta: CTA | null;
  precedingIconType?: PrecedingIconType | null;
  showDismissOption?: boolean;
  hasExpiration?: boolean;
}

export const useGetHomeBanner = () => {
  const authClient = useBffClient();
  const { loggedInUser } = useAuth();
  const { data: user } = useUser(loggedInUser ? loggedInUser.uuid : '', Boolean(loggedInUser));
  const accountId = user?.accountId ?? '';

  return useQuery<HomeBannerV1, AxiosError>(
    [CACHE_KEY_HOME_BANNER, accountId, 'get'],
    () => authClient.get(`/banner/home/${accountId}`).then(resp => resp.data.banner),
    { enabled: !!accountId, refetchOnMount: 'always' }
  );
};
